/**
 * @author Sarah Nouh
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2018-07-24 12:00
 * @description Implementation of navigate panel.
 * @filename navigate.tsx
 */
import React from "react";
import { FiveByTwoGrid } from "../lists/five-by-two-grid";
import { GridView } from "../lists/grid-view";
import { PanelNavbar } from "../page-framework/panel-navbar";

const IMAGE_URL = require("../../../static/matrix.png");

/**
 *  A React component that renders the Navigate panel.
 *
 * @export
 * @class People
 * @extends {React.Component}
 */
export class Navigate extends React.Component {
  /**
   * Returns a ReactNode containing the rendered component.
   *
   * @returns {React.ReactNode} The ReactNode containing the rendered component.
   */
  render(): React.ReactNode {
    return (
      <div className="container-fluid">
        <h3 className="panel-title text-uppercase">Navigate</h3>
        <h6 className="panel-subtitle">
          Discover the companies cutting edge bla bla{" "}
        </h6>
        <PanelNavbar
          gridContent={[
            "trending",
            "books",
            "newsletters",
            "videos",
            "articles",
            "places"
          ]}
          tabState={["active", "", "", "", "", ""]}
          tabText={[
            "Trending",
            "Books",
            "newsletters",
            "videos/podcasts",
            "articles",
            "places"
          ]}
          hasSearch={true}
        />
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="trending"
            role="tabpanel"
            aria-labelledby="trending-tab"
          >
            <GridView
              gridContent={[
                {
                  previewImageUrl: IMAGE_URL,
                  title: "Matter",
                  description: "Media + Design Thinking + Entrepreneurship"
                },
                {
                  previewImageUrl: IMAGE_URL,
                  title: "Uber: The path to $566 Billion",
                  description: "EqyBla"
                },
                {
                  previewImageUrl: IMAGE_URL,
                  title: "Recode Daily",
                  description: "Recode"
                },
                {
                  previewImageUrl: IMAGE_URL,
                  title: "How great leaders inspire action",
                  description: "Simon Sinek: TedTalk"
                },
                {
                  previewImageUrl: IMAGE_URL,
                  title: "Matter",
                  description: "Media + Design Thinking + Entrepreneurship"
                },
                {
                  previewImageUrl: IMAGE_URL,
                  title: "Matter",
                  description: "Media + Design Thinking + Entrepreneurship"
                }
              ]}
            />
            <GridView
              gridContent={[
                {
                  previewImageUrl: IMAGE_URL,
                  title: "Matter",
                  description: "Media + Design Thinking + Entrepreneurship"
                },
                {
                  previewImageUrl: IMAGE_URL,
                  title: "Uber: The path to $566 Billion",
                  description: "EqyBla"
                },
                {
                  previewImageUrl: IMAGE_URL,
                  title: "Recode Daily",
                  description: "Recode"
                },
                {
                  previewImageUrl: IMAGE_URL,
                  title: "How great leaders inspire action",
                  description: "Simon Sinek: TedTalk"
                },
                {
                  previewImageUrl: IMAGE_URL,
                  title: "Matter",
                  description: "Media + Design Thinking + Entrepreneurship"
                },
                {
                  previewImageUrl: IMAGE_URL,
                  title: "Matter",
                  description: "Media + Design Thinking + Entrepreneurship"
                }
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <FiveByTwoGrid
              title={"equity"}
              companiesLogos={[
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL
              ]}
              description={
                "Meet global startup founders changing the world with their visionary companies. Share their experiences and advice in this short-form original series."
              }
              resourcesCount={"23 resources"}
            />
          </div>
          <div className="col-md-6">
            <FiveByTwoGrid
              title={"female founders"}
              companiesLogos={[
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL,
                IMAGE_URL
              ]}
              description={
                "Meet global startup founders changing the world with their visionary companies. Share their experiences and advice in this short-form original series."
              }
              resourcesCount={"23 resources"}
            />
          </div>
        </div>
      </div>
    );
  }
}
